import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { RegistrationComponent } from './registration/registration.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LogoutComponent } from './logout/logout.component';
import { AuthComponent } from './auth.component';
import { TranslationModule } from '../i18n/translation.module';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { AlertModule } from 'src/app/alerts/alert.module';
import { ngxLoadingAnimationTypes, NgxLoadingModule } from 'ngx-loading';
import { InlineSVGModule } from 'ng-inline-svg';
import { LoginComponentDemo } from './login/login-demo/login-demo.component';

@NgModule({
  declarations: [
    LoginComponent,
    LoginComponentDemo,
    RegistrationComponent,
    ForgotPasswordComponent,
    LogoutComponent,
    AuthComponent,
    ChangePasswordComponent,
  ],
  imports: [
    CommonModule,
    TranslationModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    SweetAlert2Module,
    NgbAlertModule,
    AlertModule,
    InlineSVGModule.forRoot(),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.wanderingCubes,
      // backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      // backdropBorderRadius: '4px',
      // primaryColour: '#ffffff',
      // secondaryColour: '#ffffff',
      // tertiaryColour: '#ffffff'
    }),
  ],
})
export class AuthModule {}
